module.exports = __webpack_public_path__ + "efb363b54936d59e5435778d4524b739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/v/v28.jpg
// module id = 776
// module chunks = 0